import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: theme => ({
    flex: 1,
    backgroundColor: theme.colors.backgroundColor,
    margin: 0,
  }),
  scrollViewContainerStyle: {
    flex: 1,
    marginTop: 10,
  },
});
